(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buy-box')) {
    customElements.define(
      'buy-box',
      class BuyBox extends HTMLElement {
        constructor() {
          super();
          this.onSubmit = this.onSubmit.bind(this);
        }

        connectedCallback() {
          this.product = JSON.parse(this.querySelector('[data-buy-box-product]').textContent);
          this.product.variants = this.product.variants || [];
          this.savingTiers = this.parseSavingTiers();
          this.showPerUnit = this.dataset.showPerUnit !== 'false';
          this.form = this.querySelector('form[data-type="add-to-cart-form"]');
          this.productForm = this.querySelector('product-form');
          this.variantIdInput = this.form?.querySelector('input[name="id"]');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton?.querySelector('[data-add-to-cart-text]');
          this.submitButtonSpinner = this.submitButton?.querySelector('.loading__spinner');
          this.priceWrapper = this.querySelector('[id^="price-"]');
          this.soldOutBadgeText = this.priceWrapper?.querySelector('.price__badge-sold-out')?.textContent.trim() || '';
          this.packBadge = this.querySelector('[data-buy-box-pack-badge]');
          this.singlePanel = this.querySelector('[data-buy-box-single]');
          this.packPanel = this.querySelector('[data-buy-box-pack]');
          this.modeInputs = this.querySelectorAll('input[name^="buy-box-mode"]');
          this.packSizeInputs = this.querySelectorAll('input[name^="buy-box-pack-size"]');
          this.packItems = this.querySelectorAll('[data-pack-item]');
          this.cart = document.querySelector('cart-drawer');
          this.lastSingleVariant = null;
          this.lastPackVariant = null;
          this.quantityInput = this.querySelector('.quantity__input');

          // Single-multi specific refs
          this.singleSimpleView = this.singlePanel?.querySelector('[data-single-simple]');
          this.singleMultiView = this.singlePanel?.querySelector('[data-single-multi]');
          this.singleItems = this.querySelectorAll('[data-single-item]');
          this.singleSharedSizeInputs = this.querySelectorAll('[data-single-shared-size-input]');

          this.modeInputs.forEach((input) => input.addEventListener('change', () => this.updateMode()));
          this.packSizeInputs.forEach((input) => input.addEventListener('change', () => this.updatePackItems()));
          this.quantityInput?.addEventListener('change', () => {
            if (this.mode === 'pack') {
              this.clampPackQuantity();
              this.updatePackRowVisibility();
            } else {
              this.updateSingleView();
            }
            this.updatePrice();
          });
          this.singlePanel?.addEventListener('change', (event) => {
            const input = event.target;
            if (!input.matches('input[type="radio"], select')) return;
            // Delegate to single-multi option handler if in multi view
            if (input.dataset.singleOption !== undefined) {
              this.updateSingleMultiSelectionMetadata(input);
              this.updateSingleMultiState();
              this.updateSingleMultiMedia(input);
              this.updatePrice();
              return;
            }
            if (input.dataset.singleSharedSizeInput !== undefined) {
              if (this.getAttribute('data-individual-sizes') !== 'true') {
                this.syncSharedSizeToAllSingles(input.value);
              }
              this.updateSingleMultiState();
              this.updatePrice();
              return;
            }
            this.updateSingleSelectionMetadata(input);
            this.updateSingleState();
            this.lastSingleVariant = this.getSingleVariant();
            if (this.lastSingleVariant) {
              const rowElement = this.querySelector('[data-simple-item]');
              this.updateRowImage(rowElement, this.lastSingleVariant);
            }
            this.updatePrice();
          });
          this.querySelectorAll('[data-pack-option]').forEach((input) => {
            input.addEventListener('change', () => {
              this.updatePackSelectionMetadata(input);
              this.updatePackState();
              this.updatePackMedia(input);
              this.updatePrice();
            });
          });
          this.variantIdInput?.addEventListener('change', () => this.updateSinglePreorderFromVariantId());

          this.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-preorder-info-toggle]');
            if (!toggle) return;
            const info = toggle.parentElement.querySelector('[data-preorder-info]');
            if (info) info.hidden = !info.hidden;
          });

          this.form?.addEventListener('submit', this.onSubmit, true);
          this.addEventListener('submit', this.onSubmit, true);

          this.individualToggles = this.querySelectorAll('[data-buy-box-individual-toggle]');
          this.sharedSizeInputs = this.querySelectorAll('[data-buy-box-shared-size-input]');
          this.packHeading = this.querySelector('[data-buy-box-pack-heading]');

          this.individualToggles.forEach((toggle) => {
            toggle.addEventListener('change', () => {
              this.individualToggles.forEach((other) => {
                if (other !== toggle) other.checked = toggle.checked;
              });
              this.updateSizeSelectionMode();
            });
          });
          this.sharedSizeInputs.forEach((input) => {
            input.addEventListener('change', () => {
              this.syncSharedSizeToAllPacks(input.value);
            });
          });

          // Listen for change events bubbled from color dropdown options
          this.addEventListener('change', (event) => {
            const input = event.target;
            if (!input.matches('.buy-box__custom-select-options input[type="radio"]')) return;

            this.closeCustomDropdown(input.closest('.js-custom-select'));
            this.handleDropdownSelection(input);
          });

          // Update aria-expanded attributes based on details opening/closing
          this.querySelectorAll('.js-custom-select').forEach((details) => {
            details.addEventListener('toggle', () => {
              const summary = details.querySelector('summary');
              if (summary) {
                summary.setAttribute('aria-expanded', String(details.open));
              }
            });
          });

          // Close all custom selects when clicking outside the element
          document.addEventListener('click', (event) => {
            if (!event.target.closest('.js-custom-select')) {
              this.querySelectorAll('.js-custom-select[open]').forEach((select) => {
                select.removeAttribute('open');
                select.querySelector('summary')?.setAttribute('aria-expanded', 'false');
              });
            }
          });

          this.updateMode();
          this.updateSizeSelectionMode();

          this.lastSingleVariant = this.getSingleVariant();
          if (this.lastSingleVariant) {
            const rowElement = this.querySelector('[data-simple-item]');
            this.updateRowImage(rowElement, this.lastSingleVariant);
          }
          const packVariants = this.getPackVariants();
          this.lastPackVariant = packVariants[0] || null;
        }

        get mode() {
          return this.querySelector('input[name^="buy-box-mode"]:checked')?.value || 'single';
        }

        get packSize() {
          return Number(this.querySelector('input[name^="buy-box-pack-size"]:checked')?.value || 3);
        }

        closeCustomDropdown(details) {
          if (!details) return;
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }

        handleDropdownSelection(input) {
          const dropdownSelect = input.closest('[data-dropdown-select]');
          const optionLabel = input.closest('.buy-box__custom-select-option-label');
          const optionSwatch = optionLabel?.querySelector('.buy-box__custom-select-option-swatch');

          this.updateDropdownTrigger(
            dropdownSelect, 
            input.value, 
            optionSwatch?.innerHTML
          );
        }

        updateDropdownTrigger(container, value, swatchHtml) {
          if (!container) return;
          
          const selectedText = container.querySelector('[data-selected-dropdown-value]');
          const selectedSwatch = container.querySelector('.js-selected-swatch');

          if (selectedText) selectedText.textContent = value;
          if (selectedSwatch && swatchHtml) selectedSwatch.innerHTML = swatchHtml;
        }

        updateRowImage(rowElement, variant) {
          if (!rowElement || !variant) return;
          const img = rowElement.querySelector('.js-pack-item-image img');
          if (!img) return;

          const imageUrl = variant.featured_image?.src || this.product.variants[0]?.featured_image?.src;
          if (imageUrl) {
            img.src = this.getResizedImageUrl(imageUrl, 120);
            img.alt = `${this.product.title} in ${variant.title}`;
          }
        }

        getResizedImageUrl(url, size) {
          if (!url) return '';
          let cleanUrl = url.replace(/([?&])width=\d+/g, '');
          const separator = cleanUrl.includes('?') ? '&' : '?';
          return `${cleanUrl}${separator}width=${size}`;
        }

        updateMode() {
          const isPack = this.mode === 'pack';
          this.singlePanel.hidden = isPack;
          this.packPanel.hidden = !isPack;

          if (this.quantityInput) {
            if (!isPack) {
              this.quantityInput.setAttribute('min', '1');
              this.quantityInput.setAttribute('max', '24');
              this.quantityInput.value = 1;
            } else {
              const packSize = this.packSize;
              this.quantityInput.setAttribute('min', packSize);
              this.quantityInput.setAttribute('max', this.packItems.length);
              this.quantityInput.value = packSize;
            }
          }

          if (!isPack) {
            // Reset single mode to qty 1 simple view when switching from pack
            this.updateSingleView();
            this.updateSingleState();
            if (this.lastSingleVariant) {
              this.fetchAndUpdateMedia(this.lastSingleVariant);
            }
          } else {
            if (this.lastPackVariant) {
              this.fetchAndUpdateMedia(this.lastPackVariant);
            }
          }
          this.updatePackItems();
          this.updatePrice();
        }

        // Show simple or multi sub-view in single panel based on current quantity
        updateSingleView() {
          if (!this.singleSimpleView || !this.singleMultiView) return;

          // Bundle products have pre-set colors — never switch to the multi-color UI.
          if (this.dataset.isBundle === 'true') {
            this.singleSimpleView.hidden = false;
            this.singleMultiView.hidden = true;
            return;
          }

          const quantity = Number(this.quantityInput?.value) || 1;
          const isMulti = quantity > 1;
          this.singleSimpleView.hidden = isMulti;
          this.singleMultiView.hidden = !isMulti;
          if (isMulti) {
            this.updateSingleMultiRowVisibility(quantity);
            if (!this.isIndividualSizes) {
              const val = this.querySelector('[data-single-shared-size-input]:checked')?.value
                || this.querySelector('[data-single-shared-size-input]')?.value;
              if (val) this.syncSharedSizeToAllSingles(val);
            }
            this.updateSingleMultiState();
          }
        }

        // Show/hide single-multi rows based on quantity
        updateSingleMultiRowVisibility(quantity) {
          this.singleItems.forEach((item) => {
            item.hidden = Number(item.dataset.singleItem) > quantity;
          });
        }

        updatePackItems() {
          const size = this.packSize;
          this.packItems.forEach((item) => {
            item.hidden = Number(item.dataset.packItem) > size;
          });

          this.applyDefaultPackColors(size);

          if (this.quantityInput && this.mode === 'pack') {
            this.quantityInput.setAttribute('min', size);
            this.quantityInput.setAttribute('max', this.packItems.length);
            this.quantityInput.value = size;
          }

          if (!this.isIndividualSizes) {
            const sharedSizeInput = this.querySelector('[data-buy-box-shared-size-input]');
            if (sharedSizeInput) {
              const val = sharedSizeInput.tagName === 'SELECT' ? sharedSizeInput.value : this.querySelector('[data-buy-box-shared-size-input]:checked')?.value;
              if (val) {
                this.syncSharedSizeToAllPacks(val);
              }
            }
          }

          this.updatePackState();
          this.updatePrice();
        }

        applyDefaultPackColors(size) {
          const colorsString = this.dataset['pack' + size + 'Colors'];
          if (!colorsString) return;

          const colors = colorsString.split(',').map(c => c.trim().toLowerCase());
          const colorOptionIndex = this.product.options.findIndex(opt => opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour') + 1;
          if (colorOptionIndex === 0) return;

          const normalize = (val) => val.toLowerCase().replace(/[^a-z0-9]/g, '');

          let firstItemColorInput = null;

          this.packItems.forEach((item) => {
            const itemIndex = Number(item.dataset.packItem);
            if (itemIndex <= size) {
              const targetColor = colors[itemIndex - 1];
              if (targetColor) {
                const targetNormalized = normalize(targetColor);
                const colorInputs = item.querySelectorAll(`[data-option-position="${colorOptionIndex}"]`);
                
                let matchedInput = null;
                colorInputs.forEach((input) => {
                  if (normalize(input.value) === targetNormalized) {
                    matchedInput = input;
                  }
                });

                if (matchedInput) {
                  matchedInput.checked = true;
                  this.updatePackSelectionMetadata(matchedInput);
                  this.handleDropdownSelection(matchedInput);
                  if (itemIndex === 1) {
                    firstItemColorInput = matchedInput;
                  }
                }
              }
            }
          });

          if (firstItemColorInput) {
            this.updatePackMedia(firstItemColorInput);
          }
        }

        clampPackQuantity() {
          if (this.mode !== 'pack' || !this.quantityInput) return;

          const min = Number(this.quantityInput.min) || this.packSize;
          const max = Number(this.quantityInput.max) || this.packItems.length;
          let value = Number(this.quantityInput.value);

          if (!Number.isFinite(value)) value = min;
          value = Math.max(min, Math.min(max, value));

          if (String(value) !== this.quantityInput.value) {
            this.quantityInput.value = value;
          }
        }

        updatePackRowVisibility() {
          if (this.mode !== 'pack') return;

          const quantity = Number(this.quantityInput?.value) || this.packSize;
          this.packItems.forEach((item) => {
            item.hidden = Number(item.dataset.packItem) > quantity;
          });

          this.updatePackState();
        }

        get isIndividualSizes() {
          return Boolean(this.querySelector('[data-buy-box-individual-toggle]:checked'));
        }

        updateSizeSelectionMode() {
          const isIndividual = this.isIndividualSizes;
          this.setAttribute('data-individual-sizes', isIndividual ? 'true' : 'false');

          if (this.packHeading) {
            this.packHeading.textContent = isIndividual
              ? this.packHeading.dataset.headingIndividual
              : this.packHeading.dataset.headingShared;
          }
          
          if (!isIndividual) {
            const sharedSizeInput = this.querySelector('[data-buy-box-shared-size-input]');
            if (sharedSizeInput) {
              const val = sharedSizeInput.tagName === 'SELECT' ? sharedSizeInput.value : this.querySelector('[data-buy-box-shared-size-input]:checked')?.value;
              if (val) {
                this.syncSharedSizeToAllPacks(val);
              }
            }

            const singleSharedSizeInput = this.querySelector('[data-single-shared-size-input]');
            if (singleSharedSizeInput) {
              const val = singleSharedSizeInput.tagName === 'SELECT'
                ? singleSharedSizeInput.value
                : this.querySelector('[data-single-shared-size-input]:checked')?.value;
              if (val) {
                this.syncSharedSizeToAllSingles(val);
              }
            }
          }

          if (this.mode === 'single') {
            this.updateSingleMultiState();
            this.updatePrice();
          }
        }

        syncSharedSizeToAllSingles(selectedValue) {
          this.singleItems.forEach((item) => {
            const sizeInput = Array.from(item.querySelectorAll('[data-single-item-size-selector] input[type="radio"], [data-single-option]')).find((input) => {
              return input.closest('[data-single-item-size-selector]') && input.value === selectedValue;
            });
            if (sizeInput) {
              sizeInput.checked = true;
              this.handleDropdownSelection(sizeInput);
            }
          });
        }

        syncSharedSizeToAllPacks(selectedValue) {
          this.packItems.forEach((item) => {
            const sizeSelect = item.querySelector('select[data-pack-option]');
            if (sizeSelect) {
              sizeSelect.value = selectedValue;
              this.handleDropdownSelection(sizeSelect);
            } else {
              const sizeInput = Array.from(item.querySelectorAll('[data-pack-option]')).find((input) => {
                return input.value === selectedValue;
              });
              if (sizeInput) {
                sizeInput.checked = true;
                this.updatePackSelectionMetadata(sizeInput);
                this.handleDropdownSelection(sizeInput);
              }
            }
          });

          this.updatePackState();
          this.updatePrice();
        }

        updatePackState() {
          if (this.mode !== 'pack') return;

          const variants = this.getPackVariants();
          const hasUnavailable = variants.some((variant) => !variant || !variant.available);

          this.packItems.forEach((item, index) => {
            if (item.hidden) return;
            const error = item.querySelector('[data-pack-item-error]');
            if (error) error.hidden = Boolean(variants[index]?.available);
            this.updatePreorderMessage(item.querySelector('[data-pack-preorder-message]'), variants[index]);

            // Update row variant image
            this.updateRowImage(item, variants[index]);
          });

          if (hasUnavailable) {
            this.submitButton?.setAttribute('disabled', 'disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
          } else {
            this.submitButton?.removeAttribute('disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }

        updatePackMedia(changedInput) {
          if (this.mode !== 'pack') return;

          const packItem = changedInput.closest('[data-pack-item]');
          if (!packItem) return;

          const variant = this.findVariant(this.getSelectedOptions(packItem));
          if (!variant?.featured_media?.id) return;

          this.lastPackVariant = variant;
          this.fetchAndUpdateMedia(variant);
        }

        fetchAndUpdateMedia(variant) {
          if (!variant?.featured_media?.id) return;

          const productInfo = this.closest('product-info');
          if (!productInfo) return;

          const productUrl = productInfo.dataset.url;
          const sectionId = productInfo.sectionId || productInfo.dataset.section;

          fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              productInfo.updateMedia(html, variant.featured_media.id);
            })
            .catch((error) => {
              console.error('Buy box: error updating media', error);
            });
        }

        updateSingleState() {
          if (this.mode !== 'single') return;

          const variant = this.getSingleVariant();
          if (this.variantIdInput) {
            this.variantIdInput.value = variant?.id || '';
            this.variantIdInput.disabled = !variant?.available;
            this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (!variant) {
            this.updatePreorderMessage(this.getSinglePreorderMessage(), null);
            this.submitButton?.setAttribute('disabled', 'disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
            return;
          }

          this.updatePreorderMessage(this.getSinglePreorderMessage(), variant);

          if (variant.available) {
            this.submitButton?.removeAttribute('disabled');
            this.submitButton?.removeAttribute('aria-disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          } else {
            this.submitButton?.setAttribute('disabled', 'disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        }

        getSingleVariant() {
          return this.findVariant(this.getSelectedOptions(this.singleSimpleView || this.singlePanel));
        }

        getPackVariants() {
          return Array.from(this.packItems)
            .filter((item) => !item.hidden)
            .map((item) => this.findVariant(this.getSelectedOptions(item)));
        }

        // Build options array for a single-multi item: [color, size]
        getSingleMultiItemOptions(item) {
          if (this.isIndividualSizes) {
            return this.getSelectedOptions(item);
          }

          const color = item.querySelector(
            '[data-dropdown-select]:not([data-single-item-size-selector]) input[data-single-option]:checked'
          )?.value || item.querySelector('[data-single-option]:checked')?.value;

          let size = null;
          const sizeInput = this.singlePanel.querySelector('[data-single-shared-size-input]');
          if (sizeInput) {
            if (sizeInput.tagName === 'SELECT') {
              size = sizeInput.value;
            } else {
              size = this.singlePanel.querySelector('[data-single-shared-size-input]:checked')?.value;
            }
          }

          const options = [];
          this.product.options.forEach((optionName) => {
            const handle = optionName.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
            if (handle === 'color' || handle === 'colour') {
              if (color) options.push(color);
            } else if (handle === 'size') {
              if (size) options.push(size);
            }
          });

          return options;
        }

        // Get all visible single-multi variants (one per row)
        getSingleMultiVariants(quantity) {
          const variants = [];
          for (let i = 1; i <= quantity; i++) {
            const item = this.singlePanel?.querySelector(`[data-single-item="${i}"]`);
            if (!item || item.hidden) continue;
            const options = this.getSingleMultiItemOptions(item);
            const variant = this.findVariant(options);
            variants.push(variant || null);
          }
          return variants;
        }

        // Parse the quantity -> saving% map emitted by Liquid (data-saving-tiers).
        // Falls back to the store-default tiers if the attribute is missing/invalid.
        parseSavingTiers() {
          const fallback = { 1: 0, 2: 20, 3: 25, 4: 30, 6: 35, 8: 40 };
          const raw = this.dataset.savingTiers;
          if (!raw) return fallback;
          try {
            const parsed = JSON.parse(raw);
            const tiers = {};
            Object.keys(parsed).forEach((key) => {
              const qty = Number(key);
              const saving = Number(parsed[key]);
              if (Number.isFinite(qty) && Number.isFinite(saving)) tiers[qty] = saving;
            });
            return Object.keys(tiers).length ? tiers : fallback;
          } catch (err) {
            return fallback;
          }
        }

        // Savings table keyed by total quantity (mirrors pack discounts). Steps
        // down to the highest configured threshold that is <= the quantity.
        savingForQuantity(quantity) {
          const tiers = this.savingTiers || {};
          const thresholds = Object.keys(tiers)
            .map(Number)
            .filter((n) => Number.isFinite(n))
            .sort((a, b) => b - a);
          for (let i = 0; i < thresholds.length; i++) {
            if (quantity >= thresholds[i]) return Number(tiers[thresholds[i]]) || 0;
          }
          return 0;
        }

        // Savings table for single multi-qty (mirrors pack discounts)
        getSingleMultiSaving(quantity) {
          return this.savingForQuantity(quantity);
        }

        // Validate single-multi variants and update submit button state
        updateSingleMultiState() {
          if (this.mode !== 'single') return;
          const quantity = Number(this.quantityInput?.value) || 1;
          if (quantity <= 1) return;

          const variants = this.getSingleMultiVariants(quantity);
          const hasUnavailable = variants.some((v) => !v || !v.available);

          // Update per-row error messages
          this.singleItems.forEach((item) => {
            if (item.hidden) return;
            const itemIndex = Number(item.dataset.singleItem);
            const variant = variants[itemIndex - 1];
            const error = item.querySelector('[data-single-item-error]');
            if (error) error.hidden = Boolean(variant?.available);

            // Update preorder message for this item
            const preorderMsg = item.querySelector('[data-single-preorder-message]');
            this.updatePreorderMessage(preorderMsg, variant);

            // Update row variant image
            this.updateRowImage(item, variant);
          });

          if (hasUnavailable) {
            this.submitButton?.setAttribute('disabled', 'disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
          } else {
            this.submitButton?.removeAttribute('disabled');
            this.submitButton?.removeAttribute('aria-disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }

        // Update selected value label for single-multi color swatch
        updateSingleMultiSelectionMetadata(input) {
          if (input.type !== 'radio') return;
          const selectedValue = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
          if (selectedValue) selectedValue.textContent = input.value;
        }

        // Update product media when a color swatch changes in single-multi
        updateSingleMultiMedia(changedInput) {
          if (this.mode !== 'single') return;
          const item = changedInput.closest('[data-single-item]');
          if (!item) return;

          const options = this.getSingleMultiItemOptions(item);
          const variant = this.findVariant(options);
          if (!variant?.featured_media?.id) return;

          this.lastSingleVariant = variant;
          this.fetchAndUpdateMedia(variant);
        }

        getSelectedOptions(item) {
          const optionGroups = Array.from(item.querySelectorAll('.product-form__input'));
          if (!optionGroups.length) return this.product.variants[0]?.options || [];

          return optionGroups
            .map((group) => {
              const select = group.querySelector('select');
              if (select) return select.value;

              return group.querySelector('input[type="radio"]:checked')?.value;
            })
            .filter((value) => value != null);
        }

        updatePackSelectionMetadata(input) {
          if (input.type !== 'radio') return;

          const selectedValue = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
          if (selectedValue) selectedValue.textContent = input.value;
        }

        updateSingleSelectionMetadata(input) {
          if (input.type !== 'radio') return;

          const selectedValue = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
          if (selectedValue) selectedValue.textContent = input.value;
        }

        findVariant(options) {
          return this.product.variants.find((variant) => {
            return variant.options.every((option, index) => option === options[index]);
          });
        }

        findVariantById(variantId) {
          if (!variantId) return null;
          return this.product.variants.find((variant) => String(variant.id) === String(variantId));
        }

        getPreorderData(variant) {
          if (!variant?.id) return null;
          return this.product.preorderVariants?.[String(variant.id)] || null;
        }

        updateSinglePreorderFromVariantId() {
          if (this.mode !== 'single') return;
          this.updatePreorderMessage(this.getSinglePreorderMessage(), this.findVariantById(this.variantIdInput?.value));
        }

        getSinglePreorderMessage() {
          return this.singlePanel?.querySelector('[data-preorder-message]');
        }

        updatePreorderMessage(messageElement, variant) {
          if (!messageElement) return;

          const preorder = this.getPreorderData(variant);
          messageElement.hidden = !preorder;
          if (!preorder) return;

          const text = messageElement.querySelector('[data-preorder-message-text]');
          if (text) text.textContent = preorder.message;
        }

        updatePrice() {
          if (!this.priceWrapper) return;
          const quantity = this.quantityInput ? Number(this.quantityInput.value) : 1;

          if (this.mode === 'pack') {
            const variants = this.getPackVariants();
            const subtotal = variants.reduce((total, variant) => total + Number(variant?.price || 0), 0);
            const saving = this.packSaving;

            const finalPrice = Math.round(subtotal * ((100 - saving) / 100));
            const finalCompareAtPrice = saving > 0 ? subtotal : 0;

            const available = variants.length === quantity && variants.every((variant) => variant?.available);
            this.renderPrice({
              price: finalPrice,
              compareAtPrice: finalCompareAtPrice,
              available,
              unitCount: variants.length,
            });
            return;
          }

          // Single mode with multiple quantities: apply saving discount visual
          // (skip for bundle products — their price is managed by Shopify Bundles app)
          if (this.mode === 'single' && quantity > 1 && this.dataset.isBundle !== 'true') {
            const variants = this.getSingleMultiVariants(quantity);
            const subtotal = variants.reduce((total, v) => total + Number(v?.price || 0), 0);
            const saving = this.getSingleMultiSaving(quantity);
            const finalPrice = saving > 0 ? Math.round(subtotal * ((100 - saving) / 100)) : subtotal;
            const finalCompareAtPrice = saving > 0 ? subtotal : 0;
            const available = variants.length === quantity && variants.every((v) => v?.available);
            this.renderPrice({ price: finalPrice, compareAtPrice: finalCompareAtPrice, available, unitCount: variants.length });
            return;
          }

          const variant = this.getSingleVariant();
          if (!variant) return;

          // Single mode, quantity 1: apply the tier saving when configured
          // (default tier for qty 1 is 0%, preserving standard behavior).
          const singleSaving =
            this.mode === 'single' && this.dataset.isBundle !== 'true'
              ? this.savingForQuantity(quantity)
              : 0;
          const singleSubtotal = Number(variant.price || 0) * quantity;
          const singleCompareAt = Number(variant.compare_at_price || 0) * quantity;

          if (singleSaving > 0) {
            this.renderPrice({
              price: Math.round(singleSubtotal * ((100 - singleSaving) / 100)),
              compareAtPrice: singleSubtotal,
              available: Boolean(variant.available),
              unitCount: quantity,
            });
            return;
          }

          this.renderPrice({
            price: singleSubtotal,
            compareAtPrice: singleCompareAt,
            available: Boolean(variant.available),
            unitCount: quantity,
          });
        }

        get packSaving() {
          return Number(this.querySelector('input[name^="buy-box-pack-size"]:checked')?.dataset.packSaving || 0);
        }

        renderPrice({ price, compareAtPrice = 0, available = true, unitCount = 1 }) {
          const isOnSale = compareAtPrice > price;
          const classes = [
            'price',
            'price--large',
            available ? '' : 'price--sold-out',
            isOnSale ? 'price--on-sale' : '',
          ]
            .filter(Boolean)
            .join(' ');

          this.priceWrapper.innerHTML = `
            <div class="${classes}">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">${this.product.regularPriceLabel}</span>
                  <span class="price-item price-item--regular">${this.formatMoney(price)}</span>
                </div>
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">${this.product.regularPriceLabel}</span>
                  <span>
                    <s class="price-item price-item--regular">${this.formatMoney(compareAtPrice)}</s>
                  </span>
                  <span class="visually-hidden visually-hidden--inline">${this.product.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">${this.formatMoney(price)}</span>
                </div>
              </div>
              <span class="badge price__badge-sold-out">${this.soldOutBadgeText}</span>
            </div>
            ${this.renderPerUnit({ price, compareAtPrice, unitCount })}
          `;
        }

        // Per-unit price breakdown shown below the total (e.g. "$75.00 $37.50 each").
        // Helps price anchoring/clarity when buying more than one unit.
        renderPerUnit({ price, compareAtPrice = 0, unitCount = 1 }) {
          if (!this.showPerUnit || unitCount <= 1) return '';

          const perUnit = Math.round(price / unitCount);
          const perUnitCompareAt = compareAtPrice > price ? Math.round(compareAtPrice / unitCount) : 0;
          const eachLabel = this.dataset.perUnitLabel || 'per item';

          if (perUnitCompareAt > perUnit) {
            return `
              <div class="buy-box__per-unit" data-buy-box-per-unit>
                <s class="buy-box__per-unit-compare">${this.formatMoney(perUnitCompareAt)}</s>
                <span class="buy-box__per-unit-sale">${this.formatMoney(perUnit)} ${eachLabel}</span>
              </div>
            `;
          }

          return `
            <div class="buy-box__per-unit" data-buy-box-per-unit>
              <span class="buy-box__per-unit-sale">${this.formatMoney(perUnit)} ${eachLabel}</span>
            </div>
          `;
        }

        formatMoney(cents) {
          const format = this.product.currencyCodeEnabled
            ? this.product.moneyWithCurrencyFormat
            : this.product.moneyFormat;

          if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);

          const value = Number(cents || 0);
          const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          const defaultFormat = '$' + '{' + '{amount}' + '}';
          const formatString = format || defaultFormat;

          const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
            if (Number.isNaN(number) || number == null) return '0';

            const fixedNumber = (number / 100).toFixed(precision);
            const parts = fixedNumber.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
            const centsValue = parts[1] ? decimal + parts[1] : '';

            return dollars + centsValue;
          };

          const match = formatString.match(placeholderRegex);
          const placeholder = match?.[1] || 'amount';
          let amount = '';

          switch (placeholder) {
            case 'amount_no_decimals':
              amount = formatWithDelimiters(value, 0);
              break;
            case 'amount_with_comma_separator':
              amount = formatWithDelimiters(value, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              amount = formatWithDelimiters(value, 0, '.', ',');
              break;
            case 'amount_with_apostrophe_separator':
              amount = formatWithDelimiters(value, 2, "'", '.');
              break;
            default:
              amount = formatWithDelimiters(value, 2);
          }

          return formatString.replace(placeholderRegex, amount);
        }

        onSubmit(event) {
          // Handle single mode with qty > 1: add multiple individual items to cart
          if (this.mode === 'single') {
            const quantity = Number(this.quantityInput?.value) || 1;

            // Bundle products use Shopify's native Bundles app — let the form submit normally.
            if (this.dataset.isBundle === 'true') return;

            if (quantity > 1) {
              event.preventDefault();
              event.stopImmediatePropagation();

              if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

              const variants = this.getSingleMultiVariants(quantity);
              if (variants.some((v) => !v || !v.available)) {
                this.updateSingleMultiState();
                return;
              }

              this.addPackToCart(event, variants);
              return;
            }
            // qty = 1: let normal single-item form submit proceed
            return;
          }

          // Handle pack mode
          event.preventDefault();
          event.stopImmediatePropagation();

          if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

          const activePackVariants = this.getPackVariants();
          if (activePackVariants.some((variant) => !variant || !variant.available)) {
            this.updatePackState();
            return;
          }

          const quantity = this.quantityInput ? Number(this.quantityInput.value) : this.packSize;
          const variants = this.getPackVariantsForQuantity(quantity);

          this.addPackToCart(event, variants);
        }

        getPackVariantsForQuantity(quantity) {
          const variants = [];
          for (let i = 1; i <= quantity; i++) {
            const item = this.querySelector(`[data-pack-item="${i}"]`);
            if (item) {
              const variant = this.findVariant(this.getSelectedOptions(item));
              if (variant) {
                variants.push(variant);
              }
            }
          }
          return variants;
        }

        addPackToCart(event, variants) {
          this.handleErrorMessage();
          this.error = false;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.submitButtonSpinner?.classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify({
            items: this.getCartItemsFromVariants(variants),
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: window.location.pathname,
          });

          if (this.cart) this.cart.setActiveElement(document.activeElement);

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'buy-box',
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                this.error = true;
                return;
              }

              if (!this.cart) {
                window.openRebuyCartOrRedirect();
               return;
              }

              this.error = false;
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'buy-box',
                cartData: response,
              }).then(() => {
                this.cart.renderContents(response);
              });
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.submitButtonSpinner?.classList.add('hidden');
              CartPerformance.measureFromEvent('add:user-action', event);
            });
        }

        getCartItemsFromVariants(variants) {
          const quantitiesById = variants.reduce((items, variant) => {
            const id = Number(variant.id);
            items.set(id, (items.get(id) || 0) + 1);
            return items;
          }, new Map());

          return Array.from(quantitiesById, ([id, quantity]) => ({ id, quantity }));
        }

        handleErrorMessage(errorMessage = false) {
          const wrapper = this.querySelector('.product-form__error-message-wrapper');
          const message = wrapper?.querySelector('.product-form__error-message');
          if (!wrapper || !message) return;

          wrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage) message.textContent = errorMessage;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
